import React, { useState, useCallback, useContext } from 'react';
import { Route, Link } from 'react-router-dom';
import { PageSettings } from './../../config/page-settings.js';
import { useAuth } from '../../components/content/auth.jsx';
import { showMenu, transformMenu } from '../../components/content/coop-config.jsx';

function SidebarNavList({ data, expand, active: propActive, clicked: propClicked, visible, auth, coopConfig }) {
  const [active, setActive] = useState(-1);
  const [clicked, setClicked] = useState(-1);

  const handleExpand = useCallback(
    (e, i, match) => {
      e.preventDefault();
      setActive(prev => (active === i ? -1 : i));
      setClicked(1);
    },
    [active]
  );

  const isVisible = visible && true;
  const icon = data.icon && <i className={data.icon}></i>;
  const img = data.img && (
    <div className="icon-img">
      <img src={data.img} alt="" />
    </div>
  );
  const caret = data.children && !data.badge && <b className="caret"></b>;
  const label = data.label && <span className="label label-theme m-l-5">{data.label}</span>;
  const badgeTotal = data?.badgeType ? coopConfig.alerts[data.badgeData] : 0;
  const badgeIcon = data?.badgeType == 'bell' && badgeTotal > 0 && <i className={data.badgeIcon}></i>;
  const badge = data?.badgeType == 'badge' && badgeTotal > 0 && <span className="badge badge-warning pull-right">{badgeTotal}</span>;
  const title = data.title && (
    <span>
      {data.title} {label} {badgeIcon}
    </span>
  );
  const highlight = data.highlight && <i className="fa fa-paper-plane text-theme"></i>;

  const pageSettings = useContext(PageSettings);

  return (
    <>
      {isVisible && (
        <Route
          path={data.path}
          exact={data.exact}
          children={({ match }) => (
            <li
              className={
                (match ? 'active ' : '') +
                (propActive || (propClicked === -1 && match) || data.search ? 'expand ' : 'closed ') +
                (data.children ? 'has-sub ' : '')
              }>
              {data.children ? (
                <Link
                  to={data.path}
                  onMouseOver={e => pageSettings.handleSidebarOnMouseOver(e, data)}
                  onMouseOut={e => pageSettings.handleSidebarOnMouseOut(e, data)}
                  onClick={expand}>
                  {caret} {badge} {img} {icon} {title} {highlight}
                </Link>
              ) : (
                <Link to={data.path}>
                  {caret} {img} {icon} {badge} {title} {highlight}
                </Link>
              )}

              {data.children && (
                <ul
                  className={
                    'sub-menu ' +
                    ((propActive || (propClicked === -1 && match) || data.search) && !pageSettings.pageSidebarMinified
                      ? 'd-block '
                      : 'd-none')
                  }>
                  {data.children.map((submenu, i) => (
                    <SidebarNavList
                      key={i}
                      data={transformMenu(submenu)}
                      expand={e => handleExpand(e, i, match)}
                      active={i === active}
                      clicked={clicked}
                      visible={auth.hasAccess(submenu.permission) && showMenu(submenu) === true}
                      auth={auth}
                      coopConfig={coopConfig}
                    />
                  ))}
                </ul>
              )}
            </li>
          )}
        />
      )}
    </>
  );
}

export default props => {
  const auth = useAuth();
//   const coopConfig = useCoopConfig();
  return <SidebarNavList auth={auth} {...props} />;
};
